import { Box, IconButton, Modal, Typography } from '@mui/material';
import React, { Dispatch, ReactNode, SetStateAction } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { NewConvergeButton } from '../../../../presentation';
import { modalCommonStyle } from '../../../entity/utils';

interface RaterSubjectivitiesModalProps {
  open: boolean;
  onClose: () => void;
  title?: string | ReactNode;
  body: React.ReactNode;
  btmLabel: string;
  isDisabled?: boolean;
  setOpenNextPage?: React.Dispatch<React.SetStateAction<boolean>>;
  isDisabledBtn?: boolean;
  setIsDisabledBtn: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => Promise<void>;
}
//29784512-1850-4672-a396-c1c98ed391dd
export const RaterSubjectivitiesModal = ({
  open,
  onClose,
  title = '',
  body,
  btmLabel,
  isDisabled = false,
  handleSubmit,
}: RaterSubjectivitiesModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalCommonStyle({ height: 350, width: 800, top: '40%' })}>
        {/* Close Icon Top-Right */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'black',
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
          {title}
        </Typography>

        {/* Body */}
        <Typography id="modal-description" sx={{ mt: 2 }}>
          {body}
        </Typography>

        {/* Bottom-right Close Button */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 27,
            right: 27,
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Box style={{ marginRight: '18px' }}>
            <NewConvergeButton
              onClick={onClose}
              variant="outlined"
              label={'close'}
            ></NewConvergeButton>
          </Box>
          <NewConvergeButton
            onClick={handleSubmit}
            variant="contained"
            disabled={isDisabled}
            sx={{
              backgroundColor: 'black',
              color: 'white',
              '&:hover': {
                backgroundColor: '#333',
              },
            }}
            label={btmLabel}
          ></NewConvergeButton>
        </Box>
      </Box>
    </Modal>
  );
};
